import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
var MainContentLabelContext = /*#__PURE__*/createContext();
var MainContentLabelProvider = function MainContentLabelProvider(_ref) {
  var children = _ref.children,
    id = _ref.id;
  return /*#__PURE__*/React.createElement(MainContentLabelContext.Provider, {
    value: {
      id: id
    }
  }, children);
};
process.env.NODE_ENV !== "production" ? MainContentLabelProvider.propTypes = {
  id: PropTypes.string,
  children: PropTypes.node
} : void 0;
var useMainContentLabel = function useMainContentLabel() {
  return useContext(MainContentLabelContext);
};
export { MainContentLabelProvider, useMainContentLabel };